<template>
  <section id="login">
    <form @submit.prevent="login">
			<div class="field">
				<label for="email">Email</label>
				<input type="email" name="email" id="email" v-model.lazy="form.email"  />
			</div>
			<div class="field">
				<label for="password">Password</label>
				<div class="sub-field">
					<input :type="seePassword ? 'text' : 'password'" name="password" id="password" v-model.lazy="form.senha" />
					<button type="button" @click="seePassword = !seePassword" class="see-password">
						<i class="fas fa-eye-slash" v-if="seePassword"></i>
						<i class="fas fa-eye" v-else></i>
					</button>
				</div>
			</div>
			<div class="controls">
				<button type="submit">ENTRAR</button>
				<router-link :to="{ name: 'forgotPassword' }">Esqueci minha senha</router-link>
			</div>
		</form>
  </section>
</template>

<script>
import md5 from 'md5'
import webaula from './../../../config/webAula'
import { webAula } from '@/services/webAula'
import { usuarios } from '@/services/usuarios'
export default {
	name: 'Login',
	data () {
		return {
			seePassword: false,
			form: {
				email: '',
				senha: ''
			},
			formWebAula: {
				cpf: '',
				email: ''
			},
			tipoLogin: 'site'
		}
	},
	created () {
		// host = 1 - Presencial, 0 - EAD
		// const url = 'http://localhost:8080/site/index_dev.html#/webaula/integracao?token=ba21521d4f4adbe99b4fd708641e76fa&flagAluno=0&cpf=07982113699&host=1' // aluno
		// const url = 'http://repositorio.savaestacio.com.br/site/index.html#/webaula/integracao?token=30e0f61ded63a1c57bc5f2ade299b06f&flagAluno=0&cpf=10220286779' // docente
		const url = 'http://localhost:8080/login'
		const currentUrl = (url) || window.location
		const uri = (currentUrl.toString().indexOf('?') !== -1) ? currentUrl : ''

		if (uri) {
			const params = new URLSearchParams(uri.split('?')[1])
			const token = params.get('token')
			const host = params.get('host')
			const flagAluno = params.get('flagAluno')
			const cpf = params.get('cpf')
			const tokenGerado = md5(webaula.PALAVRA_CHAVE + params.get('cpf'))
			if (tokenGerado === token) {
				this.loginIntegrado(cpf, flagAluno, host, flagAluno)
			} else {
				alert('Dados não conferem, acesse a biblioteca virtual no webAula novamente!')
			}
		}
	},
	methods: {
		async loginIntegrado (cpf, flagAluno, host, flagEAluno) {
			let usuario = {}
			try {
				const token = await this.obterToken(host)

				if (token.data.accessToken) {
					usuario = (flagEAluno === '1') ? await this.obterAluno(cpf, host, token.data.accessToken) : await this.obterDocente(cpf, host, token.data.accessToken)
				}

				const usuarioBanco = await usuarios.webAulaVerificar(usuario.data[0].Cpf, usuario.data[0].Email)

				if (usuarioBanco.data) {
					this.atualizarUsuario(usuarioBanco.data.id, usuario.data[0])
				} else {
					const usuarioAux = usuario.data[0]
					usuarioAux.perfil = (flagEAluno === '1') ? '4' : '6'
					this.cadastrarUsuario(usuarioAux)
				}
			} catch (error) {

			}
		},
		async obterToken (host) {
			return webAula.obterToken(host)
		},

		async obterAluno (cpf, host, token) {
			return webAula.obterAluno(cpf, host, token)
		},

		async obterDocente (cpf, host, token) {
			return webAula.obterDocente(cpf, host, token)
		},

		async atualizarUsuario (usuarioId, usuario) {
			const usuarioAtualizado = await usuarios.webAulaAtualizar(usuarioId, usuario)
			this.formWebAula.cpf = usuarioAtualizado.data.cpf
			this.formWebAula.email = usuarioAtualizado.data.email
			this.tipoLogin = 'webAula'
			this.login()
		},

		async cadastrarUsuario (usuario) {
			const usuarioCadastrado = await usuarios.webAulaCadastrar(usuario)
			this.formWebAula.cpf = usuarioCadastrado.data.cpf
			this.formWebAula.email = usuarioCadastrado.data.email
			this.tipoLogin = 'webAula'
			this.login()
		},

		login () {
			this.$auth.options.loginData = { url: (this.tipoLogin === 'webAula') ? '/usuarios/autenticarWebAula' : '/usuarios/login/site', method: 'POST', fetchUser: true }
			this.$auth.login({
				data: (this.tipoLogin === 'webAula') ? this.formWebAula : this.form,
				redirect: { name: 'home' },
				error: function (erro) {
					alert(erro.response.data.erro)
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped></style>
